// @flow
import { getWebDomain } from 'shared/lib/clientSettings';
import { FFAI_DOMAIN, isFfaiPath, toFfaiPublicPath } from 'shared/lib/ffaiSite';

const stripWww = (hostname: string) =>
  (hostname.startsWith('www.') ? hostname.slice(4) : hostname);

const formatDomainAndPath = (domainUrl: string, path: string): string => {
  try {
    const { hostname } = new URL(domainUrl);
    return `${stripWww(hostname)}${path}`;
  } catch (e) {
    return path;
  }
};

const hasLocalePrefix = (path: string, locale: string): boolean =>
  path === `/${locale}` || path.startsWith(`/${locale}/`);

const isLocalhost = (): boolean => {
  if (typeof window === 'undefined') return false;
  const { hostname } = window.location;
  return hostname === 'localhost' || hostname === '127.0.0.1';
};

const getDisplayPath = (path: ?string): ?string => {
  if (!path) return path;

  if (isLocalhost()) {
    return path;
  }

  if (path.startsWith('/cxc10')) {
    const deployedPath = path.replace(/^\/cxc10/, '');
    let aixcDomain = 'https://www.aixcrypto.ai';
    if (typeof window !== 'undefined' && window._env_ && window._env_.CXC10_DOMAIN) {
      aixcDomain = window._env_.CXC10_DOMAIN;
    }
    const cleanDomain = aixcDomain.replace(/\/$/, '');
    return `${cleanDomain}${deployedPath}`;
  }

  if (isFfaiPath(path)) {
    return `${FFAI_DOMAIN}${toFfaiPublicPath(path)}`;
  }

  if (hasLocalePrefix(path, 'cn')) {
    return formatDomainAndPath(getWebDomain('CN'), path);
  }

  if (hasLocalePrefix(path, 'us') || hasLocalePrefix(path, 'ar')) {
    return formatDomainAndPath(getWebDomain('US'), path);
  }

  return path;
};

export default getDisplayPath;
